import http from 'plugins/axios';

function tenantParam(tenantId) {
  const tid = tenantId === undefined || tenantId === null || tenantId === '' ? 0 : tenantId;
  return `tenantId=${encodeURIComponent(tid)}`;
}

export default {
  tenantOptions() {
    return http.get({ url: '/la/admin/msg/channel-source/tenant-options' });
  },
  types() {
    return http.get({ url: '/la/admin/msg/channel/types' });
  },
  page({ page, size, tenantId, channelCode }) {
    let url = `/la/admin/msg/channel/page?page=${page}&size=${size}&${tenantParam(tenantId)}`;
    if (channelCode) {
      url += `&channelCode=${encodeURIComponent(channelCode)}`;
    }
    return http.get({ url });
  },
  detail(id, tenantId) {
    return http.get({ url: `/la/admin/msg/channel/detail?id=${id}&${tenantParam(tenantId)}` });
  },
  save(tenantId, data) {
    return http.post({ url: `/la/admin/msg/channel/save?${tenantParam(tenantId)}`, data });
  },
  update(tenantId, data) {
    return http.post({ url: `/la/admin/msg/channel/update?${tenantParam(tenantId)}`, data });
  },
  remove(id, tenantId) {
    return http.post({
      url: `/la/admin/msg/channel/delete?id=${id}&${tenantParam(tenantId)}`,
    });
  },
};
